import Panel from "./Panel.jsx";

export default function AlertsPanel({ alerts = [] }) {
  return (
    <Panel title="Оповещения" icon="alert">
      <div className="space-y-2">
        {alerts.length ? (
          alerts.map((alert, index) => (
            <div
              key={`${alert}-${index}`}
              className="rounded-md border border-gold/25 bg-gold/10 p-3 text-sm leading-snug text-goldSoft"
            >
              {alert}
            </div>
          ))
        ) : (
          <div className="rounded-md border border-mint/25 bg-mint/10 p-3 text-sm text-mint">
            Критические оповещения не активны.
          </div>
        )}
      </div>
    </Panel>
  );
}
